var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 2.82843 0.671573 3.5 1.5 3.5H11.5C12.3284 3.5 13 2.82843 13 2C13 1.17157 12.3284 0.5 11.5 0.5H1.5C0.671573 0.5 0 1.17157 0 2ZM0 8C0 8.82843 0.671573 9.5 1.5 9.5H11.5C12.3284 9.5 13 8.82843 13 8C13 7.17157 12.3284 6.5 11.5 6.5H1.5C0.671573 6.5 0 7.17157 0 8ZM0 14C0 14.8284 0.671573 15.5 1.5 15.5H11.5C12.3284 15.5 13 14.8284 13 14C13 13.1716 12.3284 12.5 11.5 12.5H1.5C0.671573 12.5 0 13.1716 0 14ZM15 14C15 14.8284 15.6716 15.5 16.5 15.5C17.3284 15.5 18 14.8284 18 14C18 13.1716 17.3284 12.5 16.5 12.5C15.6716 12.5 15 13.1716 15 14ZM16.5 0.5C15.6716 0.5 15 1.17157 15 2C15 2.82843 15.6716 3.5 16.5 3.5C17.3284 3.5 18 2.82843 18 2C18 1.17157 17.3284 0.5 16.5 0.5ZM15 8C15 8.82843 15.6716 9.5 16.5 9.5C17.3284 9.5 18 8.82843 18 8C18 7.17157 17.3284 6.5 16.5 6.5C15.6716 6.5 15 7.17157 15 8Z",
    fill: "#62718A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/ListView.8a00f92b.svg";
export { ForwardRef as ReactComponent };